// @mui
import Box, { BoxProps } from '@mui/material/Box';
// hooks
import { useResponsive } from 'src/hooks/use-responsive';
// components
import { useSettingsContext } from 'src/components/settings';
//
import { useRouter } from 'src/routes/hooks';
import { paths } from 'src/routes/paths';
import { HEADER, NAV } from '../config-layout';

// ----------------------------------------------------------------------

const SPACING = 16;

export default function Main({ children, openNav, sx, ...other }:  {openNav: boolean} & BoxProps) {
  const settings = useSettingsContext();

  const lgUp = useResponsive('up', 'lg');

  const isNavHorizontal = settings.themeLayout === 'horizontal';

  const noPadding = window.location.href.indexOf(paths.app.devices.map) > -1;
  if (isNavHorizontal) {
    return (
      <Box
        component="main"
        sx={{
          minHeight: 1,
          height: "100%",
          display: 'flex',
          flexDirection: 'column',
          pt: `${HEADER[settings.themeLayout].H_MOBILE + (noPadding ? 0 : 24)}px`,
          pb: noPadding ? 0 : 10,
          ...(lgUp && {
            pt: `${HEADER[settings.themeLayout].H_MOBILE + (noPadding ? 0 : 24)}px`,
            pb: noPadding ? 0 : 15,
          }),
          background: "#F2F2F2"
        }}
      >
        {children}
      </Box>
    );
  }

  return (
    <Box
      component="main"
      sx={{
        flexGrow: 1,
        minHeight: 1,
        display: 'flex',
        flexDirection: 'column',
        mt: `${HEADER[settings.themeLayout].H_MOBILE}px`,
        pt: "15px",
        position: "relative",
        pb: noPadding ? 0 : `${HEADER[settings.themeLayout].H_MOBILE + (noPadding ? 0 : SPACING)}px`,
        ...(lgUp && {
          px: noPadding ? 0 : 2,
          mt: `${HEADER[settings.themeLayout].H_DESKTOP}px`,
          pb: noPadding ? 0 : `${HEADER[settings.themeLayout].H_DESKTOP + SPACING}px`,
          width: openNav ? `calc(100% - ${NAV.W_VERTICAL}px)` : "100%",
        }),
        background: "#F9FAFA",
        ...sx,
        '@media print': {
          padding: '0px !important',
          paddingTop: '20px !important'
        }
      }}
      {...other}
    >
      {children}
    </Box>
  );
}
